<template>
  <div id="oneKeyTrans">
    <y-d-f-y-tab-bar />
    <div class="banner">
      <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/banner.png" />
    </div>
    <div class="container">
      <p>如何使用？</p>
      <span>第一步：收藏本网站到浏览器书签，将书签调整到方便的位置</span>
      <em>Windows 使用快捷键 Ctrl+D，Mac使用快捷键 Command+D 收藏书签，或者将下方按钮拖动到浏览器书签栏</em>
      <a class="collect" href="javascript: void((function() {var element = document.createElement('script');element.id = 'outfox_seed_js';element.charset = 'utf-8',element.setAttribute('src', 'http://fanyi.youdao.com/web2/seed.js?' + Date.parse(new Date()));document.body.appendChild(element);})())">
        <span>有道网页翻译2.0</span>
      </a>
      <em style="font-weight: 400;">注：使用快捷键 Ctrl+Shift+B，可显示浏览器书签栏</em>
      <span style="font-weight: 500;margin: 0 0 26px 120px">第二步：浏览英文网页时，点击浏览器书签栏中的“有道网页翻译”即可。</span>
      <div class="example">
        <div class="windows">
          <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/windows_pic1.png" alt="" srcset="">
          <i>windows</i>
        </div>
        <div class="mac">
          <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/windows_pic.png" alt="" srcset="">
          <i>mac</i>
        </div>
      </div>
    </div>
    <footer>
      <y-d-f-y-footer-bar />
    </footer>
  </div>
</template>

<script>
import YDFYTabBar from './../components/YDFYTabBar'
import YDFYFooterBar from './../components/YDFYFooterBar'
export default {
  name: 'oneKeyTrans',
  data() {
    return {}
  },
  components: {
    YDFYTabBar,
    YDFYFooterBar
  }
}
</script>

<style scoped>
.container {
  max-width: 1440px;
  min-width: 1106px;
  margin: 0 auto
}
.banner {
  width: 100%;
  overflow: hidden;
  background:rgba(251,253,255,1);
}
.banner img {
  max-width: 1200px;
  min-width: 386px;
  height: 297px;
  margin: 0 auto 56px;
}

#oneKeyTrans p {
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51,51,51,1);
  line-height: 33px;
  margin-bottom: 32px;
  margin-left: 120px;
}

#oneKeyTrans span {
  font-size: 16px;
  font-family:PingFangSC-Medium;
  font-weight: 500;
  color:rgba(51,51,51,1);
  line-height: 16px;
  display: block;
  margin: 0 0 32px 120px;
}

#oneKeyTrans em {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  color:rgba(51,51,51,1);
  line-height: 16px;
  display: block;
  margin: 0 0 32px 120px;
}

.collect {
  width: 204px;
  height: 48px;
  margin: 0 0  16px 120px;
  display: block;
  background-size: 100% 100%;
  background-image: url(https://shared-https.ydstatic.com/dict/market/webTransPc/images/bnt_bookmark.png);
}
.collect span {
  font-size: 0;
  font-weight: 700;
  line-height: 0;
  opacity: 0;
  filter: alpha(opacity = 0);
  overflow: hidden;
  text-align: center;
  zoom: 1;
}
.example {
  width: 1085px;
  height: 230px;
  margin: 0 0 152px 120px;
}
.windows, .mac {
  width: 531px;
}
.windows{
  float: left;
}
.mac {
  float: right;
}
.windows img, .mac img {
  width: 531px;
  height: 191px;
}
.example i {
  width: 100%;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51,51,51,1);
  line-height: 22px;
  display: block;
  text-align: center;
  font-style: normal;
}
footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 103px;
}
</style>
